import OrderAddressText from '../../../../Component/UI/OrderAddressText';
import styled from 'styled-components';
import { OrderList, OrderPaymentSummary } from '../../../../Component/Interface/Order';
import { claimRefundState } from '../../../../Component/UI/orderClaimProgress';
import { OrderCell } from '../../../../Component/style/orderTable_style2';

const paidDate = (value: string | null | undefined) => {
  if (!value || !Number.isFinite(Date.parse(value))) return '—';
  return new Date(value).toLocaleString('sv-SE', { timeZone: 'Asia/Seoul', hour12: false }).replaceAll('-', '.');
};

const deadlineDate = (value: string | null | undefined) => {
  if (!value || !Number.isFinite(Date.parse(value))) return null;
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit',
    day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(value));
  const part = (type: string) => parts.find(item => item.type === type)?.value;
  return `${part('year')}.${part('month')}.${part('day')} ${part('hour')}:${part('minute')}`;
};

export function hasCompletedRefund(order: OrderList, method: 'pg' | 'bank', detailSeq?: number) {
  const matches = (seq: number, paymentMethod?: string | null) => (detailSeq === undefined || seq === detailSeq)
    && ((paymentMethod || order.order_details.find(detail => detail.detail_seq === seq)?.payment_method) === 'bank' ? 'bank' : 'pg') === method;
  return (detailSeq === undefined && method === 'bank' && Number(order.bank_refund?.amount) > 0)
    || order.order_details.some(detail => matches(detail.detail_seq, detail.payment_method) && Number(detail.refund_summary?.completed_amount) > 0)
    || !!order.claims?.some(claim => claim.items.some(item => matches(item.detail_seq, item.payment_method)
      && Number(item.refund_amount ?? claim.refund_amount) > 0 && claimRefundState({
        refund_status: item.refund_status ?? claim.refund_status,
        transfer_status: item.transfer_status === undefined ? claim.transfer_status : item.transfer_status,
        status_correction: item.status_correction || claim.status_correction,
      }) === 'completed'))
    || !!order.claim_cancellations?.some(record => matches(record.detail_seq, record.payment_method)
      && record.amount > 0 && claimRefundState(record) === 'completed');
}

export default function OrderPaymentCells({ summary, order }: { summary?: OrderPaymentSummary; order?: OrderList }) {
  const pgDeadline = !summary?.pg_paid && (summary?.pg_due_amount ?? 0) > 0 ? deadlineDate(summary?.pg_deadline) : null;
  const bankDeadline = !summary?.bank_paid && (summary?.bank_due_amount ?? 0) > 0 ? deadlineDate(summary?.deposit_deadline) : null;
  const pgStatus = summary?.pg_paid ? order && hasCompletedRefund(order, 'pg') ? '결제 완료 (부분 환불)' : '결제 완료' : '결제 대기';
  const bankStatus = summary?.bank_paid ? order && hasCompletedRefund(order, 'bank') ? '입금 확인 (부분 환불)' : '입금 확인' : '입금 대기';
  return <>
    <OrderCell>{summary ? <PaymentContent><OrderAddressText address={[`${summary.pg_amount.toLocaleString('ko-KR')}원`, summary.pg_amount > 0 ? pgStatus : '', pgDeadline ? `결제 마감 ${pgDeadline}` : ''].filter(Boolean).join(' · ')}>{summary.pg_amount.toLocaleString('ko-KR')}원{summary.pg_amount > 0 && <span> · {pgStatus}</span>}{pgDeadline && <span> · 결제 마감 <time dateTime={summary.pg_deadline!}>{pgDeadline}</time></span>}</OrderAddressText>
    </PaymentContent> : '—'}</OrderCell>
    <OrderCell><OrderAddressText address={paidDate(summary?.pg_paid_at)} /></OrderCell>
    <OrderCell>{summary ? <OrderAddressText address={[`${summary.bank_amount.toLocaleString('ko-KR')}원`, summary.bank_amount > 0 ? bankStatus : '', bankDeadline ? `입금 마감 ${bankDeadline}` : ''].filter(Boolean).join(' · ')}>{summary.bank_amount.toLocaleString('ko-KR')}원{summary.bank_amount > 0 && <span> · {bankStatus}</span>}{bankDeadline && <span> · 입금 마감 <time dateTime={summary.deposit_deadline!}>{bankDeadline}</time></span>}</OrderAddressText> : '—'}</OrderCell>
    <OrderCell><OrderAddressText address={paidDate(summary?.bank_paid_at)} /></OrderCell>
  </>;
}

const PaymentContent = styled.div`
  width: 100%; min-width: 0;
`;
